class TpsLazyImage extends HTMLElement {
  constructor() {
    super();
    this.image = this.querySelector('img');
    if (!this.image) return;
    this._performance();
  }
  _performance() {
    const observePer = new IntersectionObserver((entries, observer) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          const srcset = entry.target.dataset.srcset;
          if (srcset) {
            this.image.srcset = srcset;
            observer.unobserve(this.image);
          }
        }
      });
    }, { rootMargin:'0px 32px 360px 0px', delay: 0 });
    observePer.observe(this.image);
  };
}
customElements.define('cm-lz-image', TpsLazyImage);